// `new_modalities_page` gates the redesigned Modalidades page
// (`ModalitiesPage`): modality categories scoping the whole page, modality
// cards with indicators, and the classes in their own tab with a filter per
// field. Seed migration: amsm-backend
// hall/feature_flags/migrations/0021_seed_new_modalities_page_flag.py — off
// for every tenant until an administrator turns it on.
export const NEW_MODALITIES_PAGE_FLAG = 'new_modalities_page'
